import React from 'react';

const Loader = () => {
	return (
		<div className="bouncing-loader">is loading....</div>
	);
};

export default Loader;